import styled from "styled-components";
import { primaryColor, primaryColorHover, errorColor } from "../../../../config/constants";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;
export const Modal = styled.div`
  padding: 32px;
  width: 100%;
  max-width: 384px;
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
`;
export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
export const ModalTitle = styled.h3`
  font-size: 17px;
  color: #222;
`;
export const CloseButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
`;
export const CloseIcon = styled.img`
  width: 24px;
  height: 24px;
`;
export const Description = styled.p`
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.5;
  color: #666;
`;
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
`;
export const Label = styled.label`
  margin-bottom: 6px;
  font-size: 13px;
  color: #333;
`;
export const Input = styled.input`
  padding: 9px 11px;
  width: 100%;
  border: 1px solid ${({ $hasError }) => ($hasError ? errorColor : "#dcdcdc")};
  border-radius: 5px;
  font-size: 13px;
  font-family: inherit;
  color: #333;
  outline: none;
  &::placeholder {
    color: #b5b5b5;
  }
  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? errorColor : primaryColor)};
  }
`;
export const ErrorMessage = styled.span`
  margin-top: 5px;
  font-size: 11.5px;
  color: ${errorColor};
`;
export const Buttons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 22px;
`;
const buttonStyles = `
  flex: 1;
  padding: 0 10px;
  height: 40px;
  border-radius: 5px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
`;
export const BackButton = styled.button`
  ${buttonStyles}
  border: 1px solid ${primaryColor};
  color: ${primaryColor};
  background-color: #fff;
  &:hover {
    background-color: #f2fbfc;
  }
`;
export const SaveButton = styled.button`
  ${buttonStyles}
  border: 1px solid ${primaryColor};
  color: #fff;
  background-color: ${primaryColor};
  &:hover:enabled {
    border-color: ${primaryColorHover};
    background-color: ${primaryColorHover};
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
